<template>
  <input
    class="input"
    :type="type"
    :value="value"
    :placeholder="placeholder"
    :readonly="readonly"
    :required="required"
    :disabled="disabled"
    @input="input"
  >
</template>

<script>
export default {
  name: 'InputIndex',
  props: {
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    value: {
      type: String,
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    input (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main.styl'

.input {
  width: 100%;
  border: none;

  &:focus {
    outline: none;
  }
}
</style>
